export const BAND_COLORS = {
  Critical: "#ef4444",
  "Needs Focus": "#f59e0b",
  Developing: "#eab308",
  Strong: "#22c55e",
  Exemplary: "#3b82f6",
};

export const SQAAF_NAV_ITEMS = [
  { id: "executive", label: "Executive Overview" },
  { id: "blocks", label: "Block Performance" },
  { id: "sections", label: "Domain/Section" },
  { id: "equity", label: "Equity & Segments" },
  { id: "schools", label: "School Diagnostics" },
  { id: "intervention", label: "Policy Action" },
];

/** Sidebar navigation (v3 glass layout — 5 primary sections). */
export const SQAAF_SIDEBAR_ITEMS = [
  { id: "executive", label: "Executive Overview" },
  { id: "blocks", label: "Block Performance" },
  { id: "sections", label: "Domain/Section" },
  { id: "schools", label: "School Diagnostics" },
  { id: "intervention", label: "Policy Action" },
];

export const BAND_THRESHOLDS = [40, 55, 70, 85];
